import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = {
  key: 0,
  class: "w100"
}
const _hoisted_3 = { class: "fl w30 pad10" }
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, "Zapier連携に必要なAPI KEYの確認および再発行ができます。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_9 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "API KEY:  ", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.notiDic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/zapier2.png`),
                width: "28",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_5),
              _createTextVNode("Zapier連携 ")
            ]),
            _hoisted_6,
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.notiDic.is_active == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                      style: {"height":"50px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enable(false)))
                    }, " API KEYを発行 ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.notiDic.api_key)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(_ctx.notiDic.api_key), 1),
                  _createVNode(_component_tooltip, {
                    text: "コピーしました!",
                    trigger: "manual",
                    modelValue: _ctx.showTip,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTip) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
                        width: "17",
                        height: "17",
                        class: "ml4 pointer",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyToken && _ctx.copyToken(...args)))
                      }, null, 8, _hoisted_13)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_14,
                  _createElementVNode("button", {
                    type: "submit",
                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15",
                    style: {"height":"40px"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateApiKey && _ctx.updateApiKey(...args)))
                  }, " 再発行 ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_15
  ]))
}